import { render, staticRenderFns } from "./TrendingForYou.vue?vue&type=template&id=ffc8ebcc&"
import script from "./TrendingForYou.vue?vue&type=script&lang=js&"
export * from "./TrendingForYou.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports